// ブラウザ作業で必要なトークンの取得
import store from "../../store/index";
import router from "../../../src/router";

/* Callback from Native */
// Nativeからの呼び出しに対応するため,window関数で定義

// idTokenの取得
window.jcReturnTokens = async function (tokens) {
  // tokensをstoreに格納
  store.commit("common/setTokens", tokens);

  const isApiPending = store.getters["common/isApiPending"];
  if (isApiPending) {
    // isApiPending=trueの場合、falseをセット→変更をトリガーに、authWrapperでAPIを再コールする
    store.commit("common/setIsApiPending", false);
  }
};

// ネイティブからアプリのVerが帰ってくるWindow関数
window.jcAppVersion = function (ver) {
  console.log("jcAppVersion >> " + ver);
  store.commit("common/setAppVersion", ver);
};

/* Callback from Native */

export default {
  data() {
    return {
      presetIdToken: "Bearer " + this.$store.getters["presetTokens/idToken"],
      presetAccessToken: this.$store.getters["presetTokens/accessToken"],
      lang: this.$store.getters["common/lang"],
    };
  },
  computed: {
    hasIdToken() {
      const idToken = this.$store.getters["common/idToken"];
      return idToken.length > 0;
    },
  },
  methods: {
    // デバイス判断関数
    getDevice() {
      const ua = window.navigator.userAgent.toLowerCase();
      let device = null;
      // iOS
      if (ua.indexOf("iphone") !== -1 || ua.indexOf("ipad") !== -1) {
        device = "IOS";
        // Android
      } else if (ua.indexOf("android") !== -1) {
        device = "ANDROID";
        // Other (Error)
      } else {
        device = "BROWSER";
      }

      this.$store.commit("common/setDevice", device);
      return device;
    },
    // ネイティブコールの基礎関数
    callNativeMethod(action, message = null) {
      const device = this.$store.getters["common/device"] || this.getDevice();
      let postMessage;
      switch (device) {
        case "IOS":
          try {
            if (message === null) {
              postMessage = "";
            } else {
              postMessage = message;
            }
            // eslint-disable-next-line no-undef
            webkit.messageHandlers[action].postMessage(postMessage);
          } catch (err) {
            if (process.env.VUE_APP_ENV === "development") {
              alert(err);
              return false;
            }
          }
          return true;
        case "ANDROID":
          try {
            if (message === null) {
              // eslint-disable-next-line no-undef
              android[action]();
            } else {
              postMessage = message;
              // eslint-disable-next-line no-undef
              android[action](postMessage);
            }
          } catch (err) {
            if (process.env.VUE_APP_ENV === "development") {
              alert(err);
              return false;
            }
          }
          return true;
        default:
          return false;
      }
    },
    // トークンの取得
    getTokens() {
      const done = this.callNativeMethod("ncRequestTokens");
      // alert("ネイティブコール")
      if (!done) {
        window.jcReturnTokens({
          idToken: this.presetIdToken,
          accessToken: this.presetAccessToken,
        });
      }
    },
    // 単純にWebview を閉じてネイティブに戻る
    returnNativeApp() {
      const done = this.callNativeMethod("ncCloseWeb");
      if (!done) {
        this.backToPreviousPage();
      }
    },
    // 成功処理のあと、MYチケットページのネイティブがストアページで開いていたタブへ飛ぶ
    returnNativeAppMyticketPage(idParams) {
      var done;
      // チケット購入完了からのこの関数の発火では引数が入ってくるので、masterbook_idという中身があればJSON文字列に変換してネイティブコール
      if (idParams && idParams.masterbook_id) {
        done = this.callNativeMethod("ncReturnWeb", JSON.stringify(idParams));
      } else {
        done = this.callNativeMethod("ncReturnWeb");
      }
      if (!done) {
        console.log("myチケットへ", idParams);
      }
    },
    // 非同期で新しいAPIトークンを取得したらエラーが発生したAPIコールを再度実行する。
    returnNativeAppToAccountPage() {
      const done = this.callNativeMethod("ncErrorWeb", "E00000001");
      if (!done) {
        alert("未ログインのためネイティブへ");
      }
    },
    // クレカ未登録で、クレカ登録画面へ遷移
    // services/nativeHandlerに移行
    returnNativeAppToCreditCardPage() {
      const done = this.callNativeMethod("ncErrorWeb", "E00000003");
      if (!done) {
        alert("クレカ未登録");
      }
    },
    // クレカ未登録で、クレカ登録画面へ遷移
    // services/nativeHandlerに移行
    returnNativeAppToProfile() {
      const done = this.callNativeMethod("ncErrorWeb", "E00000004");
      if (!done) {
        alert("プロファイル未登録");
      }
    },
    // 別Webviewで開くためネイティブへがいとうURLの受け渡し
    openTicket(url) {
      this.callNativeMethod("ncOpenTicket", url);
    },
    // ネイティブコールで外部リンクへ
    goToExternalLink(linkURL) {
      const done = this.callNativeMethod("ncOpenURL", linkURL);
      if (!done) {
        open(linkURL, "_blank");
      }
    },
    // ネイティブコールで外部リンクへ
    goToExternalTerms(linkURL) {
      const done = this.callNativeMethod("ncOpenTerms", linkURL);
      if (!done) {
        open(linkURL, "_blank");
      }
    },
    // ネイティブの現バージョンを取得
    ncAppVersion() {
      const device = this.$store.getters["common/device"] || this.getDevice();
      switch (device) {
        case "IOS":
          // eslint-disable-next-line no-undef
          if (webkit.messageHandlers["ncAppVersion"]) {
            // eslint-disable-next-line no-undef
            webkit.messageHandlers["ncAppVersion"].postMessage("");
          } else {
            window.jcAppVersion("undefined");
          }
          return true;

        case "ANDROID":
          // eslint-disable-next-line no-undef
          if (android["ncAppVersion"]) {
            // eslint-disable-next-line no-undef
            android["ncAppVersion"]();
          } else {
            window.jcAppVersion("undefined");
          }
          return true;

        default:
          window.jcAppVersion("2.2.0");
          return false;
      }
    },

    // ネイティブQRへの関数
    // services/nativeHandlerに移行
    ncOpenCamera(str, masterBookId = null) {
      const message =
        masterBookId != null
          ? JSON.stringify({ str, master_book_id: masterBookId })
          : str;
      const done = this.callNativeMethod("ncOpenCamera", message);
      if (!done) {
        // 特になし
        alert("QRカメラ呼び出し" + str);
      }
    },
    // 周辺・カーシェア・レンタカーでページ描画完了をマップWebviewへ知らせる関数
    ncPageReady() {
      this.callNativeMethod("ncPageReady");
    },

    // ネイティブの経路検索機能への施設名・緯度経度をjson文字列でおくる関数(周辺)
    ncGotoPlaceRecommendation(location) {
      const json = JSON.stringify({
        name: location.name,
        lat: parseFloat(location.lat),
        lng: parseFloat(location.long),
      });
      const done = this.callNativeMethod("ncGotoPlace", json);
      if (!done) {
        alert("経路検索ncRequest" + json);
      }
    },
    // ネイティブの経路検索機能への施設名・緯度経度をjson文字列でおくる関数(周辺)
    ncGotoPlaceCarShare(location) {
      const json = JSON.stringify({
        name: location.Station.Name,
        lat: parseFloat(location.GeoPoint.lati_d),
        lng: parseFloat(location.GeoPoint.longi_d),
      });
      const done = this.callNativeMethod("ncGotoPlace", json);
      if (!done) {
        alert("経路検索ncRequest" + json);
      }
    },
    // ネイティブの経路検索機能への施設名・緯度経度をjson文字列でおくる関数(周辺)
    ncGotoPlaceRentalCar(location) {
      const json = JSON.stringify({
        name: location.Office.name,
        lat: parseFloat(location.GeoPoint.lati_d),
        lng: parseFloat(location.GeoPoint.longi_d),
      });
      const done = this.callNativeMethod("ncGotoPlace", json);
      if (!done) {
        alert("経路検索ncRequest" + json);
      }
    },
    // ネイティブの検索窓ヘッダーに表示するために施設名・緯度経度をネイティブへおくる関数(周辺)
    ncSetPlaceInfoRecommendation(location) {
      const json = JSON.stringify({
        name: location.name,
        lat: parseFloat(location.lat),
        lng: parseFloat(location.long),
      });
      const done = this.callNativeMethod("ncSetPlaceInfo", json);
      if (!done) {
        // 特になし
      }
    },
    // ネイティブの検索窓ヘッダーに表示するために施設名・緯度経度をネイティブへおくる関数(カーシェア)
    ncSetPlaceInfoCarShare(location) {
      const json = JSON.stringify({
        name: location.Station.Name,
        lat: parseFloat(location.GeoPoint.lati_d),
        lng: parseFloat(location.GeoPoint.longi_d),
      });
      const done = this.callNativeMethod("ncSetPlaceInfo", json);
      if (!done) {
        // 特になし
      }
    },
    // ネイティブの検索窓ヘッダーに表示するために施設名・緯度経度をネイティブへおくる関数(レンタカー)
    ncSetPlaceInfoRentalCar(location) {
      const json = JSON.stringify({
        name: location.Office.name,
        lat: parseFloat(location.GeoPoint.lati_d),
        lng: parseFloat(location.GeoPoint.longi_d),
      });
      const done = this.callNativeMethod("ncSetPlaceInfo", json);
      if (!done) {
        console.log("ncSetPlaceInfoRentalCar json :>> ", json);
        // 特になし
      }
    },
    // ネイティブで電話アプリを開くため、電話番号を受け渡し
    ncCallPlace(tel) {
      if (tel == null) {
        this.callNativeMethod("ncCallPlace", "0000000000");
      } else {
        this.callNativeMethod("ncCallPlace", tel);
      }
    },

    // Shotlの徒歩開始地点・乗車地・降車地・目的地点の座標を送信
    ncSetPickupDropoff(tentativeReservation) {
      var json = JSON.stringify({
        desired_pickup_location: tentativeReservation.desired_pickup_location,
        desired_dropoff_location: tentativeReservation.desired_dropoff_location,
        scheduled_pickup_place: tentativeReservation.scheduled_pickup_place,
        scheduled_dropoff_place: tentativeReservation.scheduled_dropoff_place,
      });
      const done = this.callNativeMethod("ncSetPickupDropoff", json);
      if (!done) {
        // 特になし
        console.log("ncSetPickupDropoff json :>> ", json);
      }
    },

    ncBackToPreviousPage() {
      const done = this.callNativeMethod("ncBackToPreviousPage");
      if (!done) {
        // 特になし
        alert("Call native to back to previous page");
      }
    },
  },
};
